import React from 'react';
import { TableSortLabel, TableSortLabelProps } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const FilledTableSortLabel: React.FC<TableSortLabelProps> = (props) => {
  return (
    <TableSortLabel
      {...props}
      IconComponent={ArrowDropDownIcon}
      sx={{
        ...props.sx,
        '& .MuiTableSortLabel-icon': {
          opacity: props.active ? 1 : 0,
          color: (theme) => theme.palette.primary.main,
        },
        '&:hover': {
          '& .MuiTableSortLabel-icon': {
            opacity: props.active ? 1 : 0,
          },
        },
      }}
    />
  );
};

export default FilledTableSortLabel;
